// extracted by mini-css-extract-plugin
export default {"marathon__header":"marathon__header--3x7mn","marathon__layout":"marathon__layout--3buL_","marathon__main":"marathon__main--BX2mz","marathon__changelog":"marathon__changelog--2Mm-d"};
    if(module.hot) {
      // 1747648147633
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  